import { LogType } from '../enum/log-type.enum';

export class LogModel {
  userId!: number;
  userName!: string;
  dateTime!: Date;
  description!: string;
  timeDisplay!: string;
  logType: LogType;
  descriptionNo!: string;
  descriptionNO!: string;
  constructor() {
    this.logType = LogType.notFilterItem;
  }
}
